var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[(!_vm.inspection)?_c('span',{staticClass:"resize-loading"},[_c('span',{staticClass:"loader"})]):_vm._e(),(_vm.inspection)?_c('inspection-form',{attrs:{"formErrors":_vm.formErrors,"inspectionData":_vm.inspection,"loading":_vm.loading},on:{"formChanged":() => {
        _vm.alertLeave = true;
        _vm.get();
      },"inspectionSubmitted":_vm.handleSubmit,"onViewInspection":(inspection) => _vm.onViewInspection(inspection),"onCloseInspectionModal":_vm.onCloseInspectionModal}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }